import { Stack } from "@mantine/core"
import { Card, LabelWithTooltip, Switch } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import type { FeatureAccessGrant } from "../hooks/use-feature-access"

type FeatureAccessGrantCardProps = {
  readonly featureAccessGrant: FeatureAccessGrant
  readonly onUpdate: (isActive: boolean) => Promise<void>
}

export function FeatureAccessGrantCard({
  featureAccessGrant,
  onUpdate,
}: FeatureAccessGrantCardProps) {
  const { t } = useTranslation("admin")
  const label = t(`featureAccess.features.${featureAccessGrant.featureKey}`, {
    defaultValue: featureAccessGrant.featureKey,
  })
  const description = t(
    `featureAccess.featureDescriptions.${featureAccessGrant.featureKey}`,
    {
      defaultValue: featureAccessGrant.featureKey,
    }
  )

  return (
    <Card>
      <Stack gap="xs">
        <Switch
          inlineLabel
          label={
            <LabelWithTooltip
              label={label}
              fw={600}
              size="sm"
              justify="start"
              gap={2}
              hoverHelperText={description}
            />
          }
          checked={featureAccessGrant.isActive}
          onChange={(isActive) => {
            void onUpdate(isActive)
          }}
        />
      </Stack>
    </Card>
  )
}

// t("featureAccess.features.agec-compliance")
// t("featureAccess.featureDescriptions.agec-compliance")
// t("featureAccess.featureTooltips.agec-compliance")
